import React from "react";
import { Shield, ShieldHalf, ShieldCheck } from "lucide-react";
import { INSURANCES } from "../../data/tarifas";
import { eur } from "../../lib/pricing";
import { Section, StepBadge } from "./ui";

const insIcon = { shield: Shield, "shield-half": ShieldHalf, "shield-check": ShieldCheck };

function priceLabel(price) {
  if (price === null || price === undefined) return "—";
  if (price === 0) return "Incluido";
  return `${eur(price)} / día`;
}

function fianzaLabel(fianza) {
  if (fianza === null || fianza === undefined) return "—";
  if (fianza === 0) return "Sin fianza";
  return eur(fianza);
}

export default function InsuranceStep({ group, insuranceId, onSelect }) {
  return (
    <Section>
      <StepBadge n={3} title="Cobertura del seguro" subtitle="Elige tu nivel de tranquilidad" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {INSURANCES.map((ins) => {
          const Icon = insIcon[ins.icon] || Shield;
          const active = insuranceId === ins.id;
          const price = group ? ins.perDay[group] : null;
          const fianza = group ? ins.fianza[group] : null;
          return (
            <button
              key={ins.id}
              type="button"
              onClick={() => onSelect(ins.id)}
              className={`text-left rounded-xl border p-4 transition-all duration-200 ${
                active
                  ? "border-[#631024] bg-[#fbeef1] shadow-sm"
                  : "border-[#ece0e3] bg-white hover:border-[#d9c3c8] hover:shadow-sm"
              }`}
            >
              <Icon className={`w-5 h-5 mb-2 ${active ? "text-[#631024]" : "text-[#9b8388]"}`} />
              <h3 className="font-display font-bold text-[#2a1a1e]">{ins.name}</h3>
              <p className="text-xs text-[#9b8388] mt-1 leading-snug min-h-[32px]">{ins.desc}</p>
              <p className="text-sm font-semibold text-[#631024] mt-2">{priceLabel(price)}</p>
              <p className="text-xs text-[#9b8388]">Fianza: {fianzaLabel(fianza)}</p>
            </button>
          );
        })}
      </div>
    </Section>
  );
}
